// extracted by mini-css-extract-plugin
export default {"input":"CustomInputText_input__fK92d"};